<template>
    <div>
        <TheHeader class="mob-header" />
        <div class="banner">
            <img v-if="getInfor.banner!=null && getInfor.banner!=''" :src="getInfor.banner">

            <template v-else-if="getInfor.video!=null && getInfor.video!=''">
                <img 
                    class="video-cover" 
                    v-if="videoCover === true" 
                    :src="'./images/detail/mob-media-cover.png'"
                >
                <img 
                    class="video-play" 
                    v-if="!videoPlay" 
                    src="@/assets/images/base-play.png"  
                    :class="{played: videoCover === true}"
                    @click="playVideo"
                >
                <!-- <img 
                    class="video-pause" 
                    v-else-if="videoPlay" 
                    src="@/assets/images/base-pause.png"
                    @click="pauseVideo"
                > -->
                <div class="video-box">
                    <video 
                        controls 
                        playsinline="true" 
                        webkit-playsinline="true"
                        ref="detaliTopVideo" 
                        class="banner-video"
                        :class="{on: videoCover === false}" 
                        :src="getInfor.video" 
                    ></video>
                </div>
            </template>
        </div>
        <BaseTitle :infor="getInfor" />
        <BaseArcticle :list="getInfor.list" />

        <BasePageTurning :infor="infor" />

        <TheFooter class="mob-the-footer-other" />
    </div>
</template>

<script>
    
    import TheHeader from '@/components/module/TheHeader'
    import TheFooter from '@/components/module/TheFooter'
    import '@/assets/less/module/module-the-header_mob-header.less'
    import '@/assets/less/module/module-the-footer-other_mob-the-footer-other.less'
    
    import BaseTitle from '@/components/module/BaseTitle'
    import BaseArcticle from '@/components/module/BaseArcticle'
    import BasePageTurning from '@/components/module/BasePageTurning'

    export default {
        name: 'MobDetail',
        props: {
            infor: Object
        },
        components: {
            TheHeader,
            TheFooter,
            BaseTitle,
            BaseArcticle,
            BasePageTurning
        },
        data () {
            return {
                videoPlay: false,
                videoCover: true
            }
        },
        computed: {
            getInfor: function(){
                let obj =  JSON.parse(JSON.stringify(this.infor));
                obj.banner = obj.mobBanner;
                let arr = obj.list;
                for(var i=0, l=arr.length; i<l; i++) {
                    if( arr[i].type === 'image' ) {
                        arr[i].images = arr[i].mobImages
                    }
                }
                return obj;
            }
        },
        mounted () {},
        methods: {
            initVideo: function(){
                let _this = this;
                let video = this.$refs.detaliTopVideo;
                if(video){
                    video.addEventListener('pause',function(){
                        _this.videoPlay = false;
                    });
                    video.addEventListener('play',function(){
                        _this.videoPlay = true;
                    });
                }
            },
            playVideo: function(){
                let dom = this.$refs.detaliTopVideo;
                dom.play();
                this.videoCover = false;
                this.videoPlay = true;
                // this.initVideo();

            },
            pauseVideo: function(){
                let dom = this.$refs.detaliTopVideo;
                dom.pause();
                this.videoPlay = false;
            } 
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*导航*/
.banner {
    position: relative;
    text-align: center;
    width: 100%;
    overflow: hidden;
}
.video-cover {
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    min-height: 5.62rem;
    background: black;
    pointer-events: none;
}
.video-pause,
.video-play {
    position: absolute;
    z-index: 12;
    top: 50%;
    left: 50%;
    width: 1.5rem;
    height: 1.5rem;
    margin: -.75rem 0 0 -.75rem;
    cursor: pointer;
}

.banner:hover .video-play.played,
.banner:hover .video-pause {
    display: block;
}
.video-box {
    min-height: 5.62rem;
    background: #000;
}
.banner-video {
    width: 100%;
    height: 1px;
    display: block;
    opacity: 0;
    background: #000;
}
.banner-video.on {
    height: auto;
    opacity: 1;
}
.title-box {
    padding: .32rem 0;
}

</style>